"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DialogActions = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
/**
 * A wrapper for `Dialog` action content.
 *
 * @related [`Dialog`]
 * @since 7.0.0
 */
var DialogActions = /*#__PURE__*/_styledComponents.default.div.withConfig({
  displayName: "DialogActions",
  componentId: "c11n-8-107-0__sc-12x2o37-0"
})([""]);
exports.DialogActions = DialogActions;
DialogActions.displayName = 'DialogActions';

/** @component */